import { createFileRoute } from "@tanstack/react-router";
import { AppLayout } from "@pages/app-layout/app-layout";

export const Route = createFileRoute("/_authenticated/app")({
  component: AppLayout,
});
